/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Editor, { IEditor } from '../Editor';

interface RHFEditor extends IEditor {
  name: string;
  onChange?: (event: any) => void;
}

interface EditorValue {
  htmlValue: string;
  textValue: string;
  delta?: any;
  source?: string;
}

const RHFEditor: React.FC<RHFEditor> = ({ name, onChange, ...props }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange: onFieldChange }, fieldState: { error } }) => {
        // Handle the value conversion to ensure we're passing a string to the Editor
        let editorValue = '';
        
        // If value is an object with htmlValue property, extract that
        if (typeof value === 'object' && value !== null && 'htmlValue' in value) {
          editorValue = value.htmlValue || '';
        } 
        // If it's a string, use it directly
        else if (typeof value === 'string') {
          editorValue = value;
        }

        const handleEditorChange = (editorOutput: EditorValue) => {
          // Store the complete editor output object
          onFieldChange(editorOutput);
          
          // Call external onChange if provided
          if (onChange) {
            onChange(editorOutput);
          }
        };

        return (
          <Editor
            id={name}
            name={name}
            value={editorValue}
            onChange={handleEditorChange}
            {...props}
          />
        );
      }}
    />
  );
};

export default RHFEditor;
